// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1yYLw","bigColWidth":"Table_bigColWidth__2oddL","biggerColWidth":"Table_biggerColWidth__3h55u","row":"Table_row__2SkfY","col":"Table_col__3CNfG"};